import { useHandleSignInCallback } from '@logto/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';

const RETURN_TO_KEY = 'omnizen.returnTo';

export function LoginCallback() {
  const { t } = useTranslation();
  const { theme } = useTheme();
  const navigate = useNavigate();

  const { isLoading } = useHandleSignInCallback(() => {
    // If a stale-session re-auth stashed a return URL, honor it.
    let target = '/';
    try {
      const stashed = sessionStorage.getItem(RETURN_TO_KEY);
      if (stashed) {
        sessionStorage.removeItem(RETURN_TO_KEY);
        // Convert absolute URL back to a path so react-router handles it.
        const url = new URL(stashed);
        if (url.origin === window.location.origin) {
          target = `${url.pathname}${url.search}${url.hash}`;
        }
      }
    } catch {
      // Fall through to '/'.
    }
    navigate(target, { replace: true });
  });

  return (
    <div className={`app theme-${theme}`}>
      <div className="loading-screen">{isLoading ? t('signingIn') : t('loading')}</div>
    </div>
  );
}
